// removed by extract-text-webpack-plugin
module.exports = {"title":"c-GroupTitle__title","accent":"c-GroupTitle__accent","big":"c-GroupTitle__big"};